function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.23,6.12H5.77A.84.84,0,0,0,4.92,7v4.89a.85.85,0,0,0,.85.85h8.46a.85.85,0,0,0,.85-.85V7A.84.84,0,0,0,14.23,6.12Zm.33,6H5.44V6.73h9.12Z",
  transform: "translate(-0.96 -0.95)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.18,13.61V13H8.82v.66a.51.51,0,0,1-.5.5h0a.25.25,0,0,0-.26.25h0a.25.25,0,0,0,.26.26h3.36a.25.25,0,0,0,.26-.26h0a.25.25,0,0,0-.26-.25h0A.51.51,0,0,1,11.18,13.61Z",
  transform: "translate(-0.96 -0.95)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.18,9.86h0a.22.22,0,0,1,0-.32,1.41,1.41,0,0,1,1.6,0,.22.22,0,0,1,0,.32h0a.21.21,0,0,1-.26,0,1,1,0,0,0-1.12,0A.21.21,0,0,1,9.18,9.86Z",
  transform: "translate(-0.96 -0.95)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.32,9.36a.2.2,0,0,1-.28,0A1.68,1.68,0,0,0,9,9.37a.2.2,0,0,1-.28,0h0A.22.22,0,0,1,8.7,9a2.1,2.1,0,0,1,2.6,0,.22.22,0,0,1,0,.32Z",
  transform: "translate(-0.96 -0.95)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.87,8.81a.2.2,0,0,1-.28,0,2.47,2.47,0,0,0-3.18,0,.2.2,0,0,1-.28,0h0a.2.2,0,0,1,0-.31,2.85,2.85,0,0,1,3.72,0,.2.2,0,0,1,0,.31Z",
  transform: "translate(-0.96 -0.95)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10,10.19a.37.37,0,1,0,.37.37A.37.37,0,0,0,10,10.19Z",
  transform: "translate(-0.96 -0.95)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10,19.05a9.05,9.05,0,1,1,9-9A9.06,9.06,0,0,1,10,19.05Zm0-17.2A8.15,8.15,0,1,0,18.14,10,8.16,8.16,0,0,0,10,1.85Z",
  transform: "translate(-0.96 -0.95)"
});

var SvgHandlesSocialIconMeet = function SvgHandlesSocialIconMeet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a6b70c28-67d3-41be-9cc6-46edad70a91f",
    "data-name": "Layer 1",
    viewBox: "0 0 18.08 18.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandlesSocialIconMeet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Handles_SocialIcon_Meet.c9e07057.svg";
export { ForwardRef as ReactComponent };